module.exports = {
  email: 'shovondas26@gmail.com',
  openToWork: false,
  resume: {
    url: '/__resume.pdf',
  },
  resumeNotice: {
    title: 'Resume',
    message: 'Resume access is on a need-to-know basis. If you’re hiring, I’ll make an exception.',
    actionLabel: 'Send email',
  },
  instagramNotice: {
    title: 'Instagram',
    message: 'Instagram is quiet here. If you want the real story, email works better.',
    actionLabel: 'Send email',
  },
  redactionCopy: {
    jobs: 'The short version: I build systems that behave. Full details on request.',
    projects: 'If it is here, it shipped. Full story on request.',
    archive: 'Details on request.',
  },

  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/shovoncse',
    },
    // {
    //   name: 'Twitter',
    //   url: 'https://twitter.com/shovancse',
    // },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/shovoncse',
    },
    // {
    //   name: 'Codepen',
    //   url: '#',
    // },
    {
      name: 'Instagram',
      url: 'https://media.licdn.com/dms/image/D4E12AQEJlh4lVJfFgw/article-cover_image-shrink_720_1280/0/1714832827876?e=2147483647&v=beta&t=-zReLxhdsU0PtitA6CdNOuSxyxrva1SJsRpuBHu760o',
      notice: 'instagram',
    },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Work',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  colors: {
    green: '#64ffda',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
